import React, { useEffect, useState } from 'react';
import { devApi } from '../../services/api';
import {
  PageTitle,
  PageDescription,
  Card,
  Table,
  PlanTag,
  ErrorMessage,
  LoadingMessage,
} from './styles';

export default function DevSubscriptions() {
  const [subscriptions, setSubscriptions] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    devApi
      .getSubscriptions()
      .then((res) => {
        if (!cancelled) {
          setSubscriptions(Array.isArray(res) ? res : []);
          setError(null);
        }
      })
      .catch((err: any) => {
        if (!cancelled) {
          setError(err?.response?.data?.message || err?.message || 'Failed to load subscriptions');
          setSubscriptions([]);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) {
    return <LoadingMessage>Loading subscriptions…</LoadingMessage>;
  }
  if (error) {
    return (
      <>
        <PageTitle>Subscriptions</PageTitle>
        <ErrorMessage>{error}</ErrorMessage>
      </>
    );
  }

  return (
    <>
      <PageTitle>Subscriptions</PageTitle>
      <PageDescription>Users with paid subscriptions: plan, interval, next billing.</PageDescription>
      <Card>
        <Table>
          <thead>
            <tr>
              <th>Athlete</th>
              <th>Owner / Email</th>
              <th>Plan</th>
              <th>Interval</th>
              <th>Status</th>
              <th>Next billing</th>
              <th>Cancel at period end</th>
            </tr>
          </thead>
          <tbody>
            {subscriptions.map((s) => (
              <tr key={s.athleteId}>
                <td>{s.athleteName}</td>
                <td>
                  {s.ownerName && s.ownerEmail ? `${s.ownerName} (${s.ownerEmail})` : s.ownerEmail || '—'}
                </td>
                <td><PlanTag $plan={s.plan}>{s.plan || 'free'}</PlanTag></td>
                <td>{s.billingPeriod || '—'}</td>
                <td>{s.status || '—'}</td>
                <td>
                  {s.nextBillingDate ? new Date(s.nextBillingDate).toLocaleDateString() : '—'}
                </td>
                <td>{s.cancelAtPeriodEnd ? 'Yes' : 'No'}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Card>
    </>
  );
}
